<div class=" border border-primary modal-content mt-3 mt-sm-5 ">
    <div class="row cc-top ">
        <h2>Ooops... Resource Not Found.</h2>
        <div class="custom-separator my-4 mx-auto bg-primary"></div>
        <div class="tipper-image">
            <img class="w-100" alt="Not Able To Locate" src="../../../assets/splash/oops.png" loading="lazy" />
        </div>
        <p class="">Unable to locate the details you've requested. Please update your link or 
            <a class="btn btn-primary mt-3" [routerLink]="[ urlPaths.WELCOME ]">retry.</a></p>
    </div>
</div>